module.exports = __webpack_public_path__ + "img/background-study-registration.a497d159.jpg";